import { useTheme } from "@/components/theme-provider";
import { Card, CardContent } from "@/components/ui/card";
import { useAuth } from "@/hooks/auth/use-auth";
import { usePageTitle } from "@/hooks/use-page-title";
import { HighRecentEngagementCampaigns } from "./high-recent-engagement-campaigns";
import { ProspectAccountsWithHighEngagement } from "./prospect-accounts-with-high-engagement";
import { RecentOpenedOpportunities } from "./recent-opened-opportunities";
import { RecentWonOpportunities } from "./recent-won-opportunities";

export default function HomePage() {
  usePageTitle("Home");
  const { user } = useAuth();
  const { effectiveTheme } = useTheme();

  return (
    <div className="space-y-12">
      <div className="shrink-0">
        <div className="flex flex-col space-y-4 pt-4 sm:flex-row sm:items-center sm:space-y-0 sm:space-x-4">
          <h1 className="font-heading">Home</h1>
        </div>
      </div>

      <div className="flex gap-6">
        <div className="w-1/4 relative">
          <img
            src={
              effectiveTheme === "dark"
                ? "/upside-icon-dark.svg"
                : "/upside-icon-light.svg"
            }
            alt="Upside icon"
            className="h-24 w-24 flex-shrink-0 absolute left-1/2 -translate-x-1/2 top-0 -translate-y-1/2 z-10"
          />
          <Card>
            <CardContent className="pt-16">
              <div className="flex flex-col items-start gap-4">
                <h3 className="text-lg font-medium w-full text-center">
                  Welcome{user?.first_name ? `, ${user.first_name}` : ""}
                </h3>
                <div className="text-left w-full">
                  <p className="text-sm text-muted-foreground">
                    Upside helps you see what happened in all of your deals, so
                    you can understand what worked.
                  </p>
                  <p className="text-sm text-muted-foreground mt-2">
                    Not sure where to start?
                  </p>
                  <p className="text-sm text-muted-foreground font-semibold">
                    See the cards on the right for a few ideas!
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="w-3/4 flex flex-col gap-6">
          <RecentOpenedOpportunities limit={5} />
          <RecentWonOpportunities limit={5} />
          <HighRecentEngagementCampaigns limit={5} />
          <ProspectAccountsWithHighEngagement limit={5} />
        </div>
      </div>
    </div>
  );
}
